import PropTypes from 'prop-types';
import { createModelSegment } from 'client/data/luckdragon/segment';
import { sample, random } from 'client/utils/seed-randomizers';

export const PAGE_SURVEY_RECIPE = {
  NONE: 'ctrl',
  MARKETING: 'chal-mktg',
  BRAND: 'chal-brandassoc',
  EXIT: 'chal-csat',
};

export const EMAIL_GATE_RECIPE = {
  CTRL: 'ctrl',
  CHAL: 'chal',
};

const HERO_IMAGES_MAP = {
  car_reviews_landing: [
    {
      mobile: '/img/landing-hero/car_reviews_landing_S_4.jpg',
      desktop: '/img/landing-hero/car_reviews_landing_L_4.jpg',
    },
  ],
};

const HeroImage = PropTypes.shape({
  mobile: PropTypes.string,
  desktop: PropTypes.string,
});

const TransactionsCountAdjustments = PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number));

export const RandomPropTypes = {
  HeroImage,
  TransactionsCountAdjustments,
};

function getHeroImagePath(page) {
  return `heroImage["${page}"]`;
}

function getTransactionsCountAdjustments(count) {
  return count > 1 ? `transactionsCountAdjustments["${count}"]` : null;
}

function getPageSurveyRecipePath() {
  return 'pageSurveyRecipe';
}

function getEmailGateRecipePath() {
  return 'emailGateRecipe';
}

export const RandomPaths = {
  getHeroImagePath,
  getTransactionsCountAdjustments,
  getPageSurveyRecipePath,
  getEmailGateRecipePath,
};

/**
 * This model is used to randomize server-side content without any API calls
 */
export const RandomModel = createModelSegment('random', [
  /**
   * @see getHeroImagePath
   */
  {
    path: 'heroImage["{page}"]',
    resolve({ page }) {
      return Promise.resolve(sample(HERO_IMAGES_MAP[page] || []));
    },
  },
  /**
   * Creates adjustments from -0.2 to 0.2
   * @see getTransactionsCountAdjustments
   */
  {
    path: 'transactionsCountAdjustments["{count}"]',
    resolve({ count }) {
      return Promise.resolve(
        new Array(4)
          .fill()
          .map(() => new Array(parseInt(count, 10)).fill().map(() => parseFloat((random() * 0.4 - 0.2).toFixed(2))))
      );
    },
  },
  /**
   * @see getPageSurveyRecipePath
   */
  {
    path: 'pageSurveyRecipe',
    resolve() {
      const randomPercent = random() * 100;

      switch (true) {
        case randomPercent < 0.5: {
          return Promise.resolve(PAGE_SURVEY_RECIPE.MARKETING);
        }
        case randomPercent >= 0.5 && randomPercent < 1.5: {
          return Promise.resolve(PAGE_SURVEY_RECIPE.BRAND);
        }
        case randomPercent >= 1.5 && randomPercent < 2.5: {
          return Promise.resolve(PAGE_SURVEY_RECIPE.EXIT);
        }
        default: {
          return Promise.resolve(PAGE_SURVEY_RECIPE.NONE);
        }
      }
    },
  },
  /**
   * @see getEmailGateRecipePath
   */
  {
    path: 'emailGateRecipe',
    resolve() {
      return Promise.resolve(random() < 0.5 ? EMAIL_GATE_RECIPE.CTRL : EMAIL_GATE_RECIPE.CHAL);
    },
  },
]);
